let apikey = ''
if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
    apikey = ''
} else {
    apikey = 'AIzaSyC7KejzkMhG6P0ofYB4W6ypYaN-qrcvhYI'
}

const API_KEY = apikey

const CALLBACK_NAME = 'gmapsCallback'

let initalized = !!window.google;
let resolveInitPromise;
let rejectInitPromise;

const initPromise = new Promise((resolve, reject) => {
    resolveInitPromise = resolve
    rejectInitPromise = reject
});

export default function init() {
    if (initalized) return initPromise;

    initalized = true;
    window[CALLBACK_NAME] = () => resolveInitPromise(window.google);

    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&callback=${CALLBACK_NAME}`;
    script.onerror = rejectInitPromise;
    document.querySelector('head').appendChild(script);

    return initPromise;
}